import { render, staticRenderFns } from "./sideNotice.vue?vue&type=template&id=78756574&scoped=true&"
import script from "./sideNotice.vue?vue&type=script&lang=js&"
export * from "./sideNotice.vue?vue&type=script&lang=js&"
import style0 from "./sideNotice.vue?vue&type=style&index=0&id=78756574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78756574",
  null
  
)

export default component.exports